import React, { useState } from "react";
import { RouterSwitch } from "./RouterSwitch";
import { Route } from "react-router";
import Footer from "./Footer";
import Content from "./Content";
import Notifications
  from "../widget/Notifications";
import Error404 from "./Error404";
import TopBar from "./TopBar";

import { UserContext } from '../context/UserContext';
import Auth from "../auth/Auth";
import ContactAdministratorError from "./ContactAdministratorError";
import CampaignPage from "../pages/campaign/CampaignPage";
import KanbanPage from "../pages/kanban/KanbanPage";
import {
  NotificationsCounterContext
} from "../context/NotificationsCounterContext";

export const RouteContext = React.createContext(null);

const ApplicationStateful = () => {
  const routesState = useState({ routes: [], breadcrumbs: [] });
  const [user, setUser] = useState({});
  const [notificationsCounter, setNotificationsCounter] = useState({});

  return (
    <RouteContext.Provider value={routesState}>
      <UserContext.Provider value={{ user, setUser }}>
        <NotificationsCounterContext.Provider
          value={{ notificationsCounter, setNotificationsCounter }}>
          <Auth>
            <Notifications>
              <TopBar />
              {/*<Drawer url={"this.props.location.pathname"}/>*/}
              <div id="main-section" className="is-main-section-container">
                <Content>
                  <RouterSwitch>
                    <Route path="/" index element={<CampaignPage />} />
                    <Route path="/kanban/:id" index element={<KanbanPage />} />

                    <Route path="account-error" element={<ContactAdministratorError />} />
                    <Route path="*" element={<Error404 />} breadcrumb={false} />
                  </RouterSwitch>
                </Content>
                <Footer />
              </div>
            </Notifications>
          </Auth>
        </NotificationsCounterContext.Provider>
      </UserContext.Provider>
    </RouteContext.Provider>
  )
}

export default ApplicationStateful;

